<template>
  <div class="index-swiper">
    <swiper :options="swiperOptions" v-if="showSwiper">
      <swiper-slide v-for="item of value" :key="item.id">
        <template v-if="$bti.ServerUrl + item.ADREMARK"><img
          class="swiper-img"
          :src="
            $bti.ServerUrl + item.ADREMARK
          "
          @click="GotoAdUrl(item.ADURL)"
        /></template>
        <template v-else><img src="/static/img/np-img.png" /></template>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "HomeSwiper",
  props: ["value"],
  data: function () {
    return {
      swiperOptions: {
        pagination: ".swiper-pagination",
        loop: true,
        autoplay: 2500,
        mousewheelControl: false,
        paginationClickable: true,
      },
    };
  },
  computed: {
    showSwiper: function () {
      return this.value.length;
    },
  },
  mounted: function () {},
  methods: {
    GotoAdUrl(url) {
      if (url == null) {
        return;
      }
      window.open(url);
    },
  },
};
</script>

<style lang="css" scoped>
.index-swiper .swiper-container {
  width: 100%;
  height: 100%;
}
.index-swiper .swiper-container .swiper-slide {
  text-align: center;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.index-swiper .swiper-container .swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  /*object-fit: cover;*/
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Swiper.vue